import { render, staticRenderFns } from "./ExcelExports.vue?vue&type=template&id=beb20ed0&"
import script from "./ExcelExports.vue?vue&type=script&lang=js&"
export * from "./ExcelExports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports